import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleShowTotal } from 'store/filters/filters-actions';
import totalPriceChanged from 'segment/events/search/total-price-changed';
import { useShowTotal } from 'store/selectors/hooks/useShowTotal';
import { FilterCheckboxBase } from '../../../filter-bases';
import { persistTotalPriceSessionPreference } from 'utils/total-price-session-utils';
import { Switch, Box } from '@spothero/ui';
import { SearchPageView } from 'utils/search-page-view';
const DesktopTotalToggle = ({ showTotal, onChange, }) => (<Box flex="1 1 auto" justifySelf="flex-end" sx={{
        '.chakra-form-control': {
            display: 'flex',
            flexFlow: 'row-reverse',
            alignItems: 'center',
            gap: 2,
        },
        '.chakra-form__label': {
            marginBottom: 0,
        },
    }} data-testid="DesktopTotalToggle">
        <Switch label={'Show total price with fees'} isChecked={showTotal} onChange={onChange}/>
    </Box>);
export default function TotalToggle() {
    const dispatch = useDispatch();
    const state = useSelector((s) => s);
    const view = useSelector((s) => s.search.data.view);
    const showTotal = useShowTotal();
    const [isClient, setIsClient] = useState(false);
    const handleClick = () => {
        dispatch(toggleShowTotal(!showTotal));
        persistTotalPriceSessionPreference(!showTotal);
        totalPriceChanged(state);
    };
    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient) {
        // Early return
        return <div data-testid="notClient-totalToggle"/>;
    }
    if (view === SearchPageView.DESKTOP_LIST) {
        // Desktop return
        return (<DesktopTotalToggle showTotal={showTotal} onChange={handleClick}/>);
    }
    return (
    // Default return
    <FilterCheckboxBase testid={`QuickFilters-showTotal-${showTotal}`} onClick={handleClick} isActive={showTotal}>
            Total Price
        </FilterCheckboxBase>);
}
